import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import './index.css';
import App from './App';
import AdminApp from './admin/AdminApp';
import NewsDetail from './NewsDetail';
import NewsPage from './NewsPage';
import ProductDetail from './ProductDetail';
import SeedVarietyIndex from './SeedVarietyIndex';
import SeedVarietyDetail, { SeedVarietyProductRedirect } from './SeedVarietyDetail';
import CropCategoryPage from './CropCategoryPage';
import GalleryPage from './GalleryPage';
import AboutPage from './AboutPage';
import GalleryAlbumPage from './GalleryAlbumPage';
import reportWebVitals from './reportWebVitals';
import HistoryPage from './HistoryPage';
import FarmerPage from './FarmerPage';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/admin/*" element={<AdminApp />} />
        <Route path="/news" element={<NewsPage />} />
        <Route path="/news/:articleId" element={<NewsDetail />} />
        <Route path="/products/:productId" element={<ProductDetail />} />
        <Route path="/crops/:categoryId" element={<CropCategoryPage />} />
        <Route path="/seed-varieties" element={<SeedVarietyIndex />} />
        <Route path="/seed-varieties/:productId" element={<SeedVarietyProductRedirect />} />
        <Route path="/seed-varieties/:productId/:variantId" element={<SeedVarietyDetail />} />
        <Route path="/gallery/album/:albumId" element={<GalleryAlbumPage />} />
        <Route path="/gallery" element={<GalleryPage />} />
        <Route path="/farmer" element={<FarmerPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/history" element={<HistoryPage />} />
        <Route path="/*" element={<App />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
